import {AlertsDao} from './dao/alerts_dao';
import {AuthDao} from './dao/auth_dao';
import {BinMgrDao} from './dao/binmgr_dao';
import {BruteForceDao} from './dao/brute_force_dao';
import {CompLicensesDao} from './dao/comp_licenses_dao';
import {ComponentsDao} from './dao/components_dao';
import {DatabaseSyncDao} from './dao/database_sync_dao';
import {XrayEffectivePermissionsDao} from './dao/effective_permissions_dao.js';
import {EventXDao} from './dao/eventx_dao';
import {FailedMessagesDao} from './dao/failed_messages_dao';
import {XrayFooterDao} from './dao/footer_dao';
import {GeneralDao} from './dao/general_dao';
import {GeneralSettingsDao} from './dao/general_settings_dao';
import {HADao} from './dao/ha_dao';
import {HomepageDao} from './dao/homepage_dao';
import {IgnoreDao} from './dao/ignore_dao';
import {ImpactDao} from './dao/impact_dao';
import {IntegrationDao} from './dao/integration_dao';
import {LicenseDao} from './dao/license_dao';
import {xrayLicensesDao} from './dao/licenses_dao';
import {LogsDao} from './dao/logs_dao';
import {XrayMailDao} from './dao/mail_dao';
import {MonitorDao} from './dao/monitor_dao';
import {XrayNameValidatorDao} from './dao/name_validator_dao';
import {XrayOnboardingDao} from './dao/onboarding_dao';
import {XrayPermissionsDao} from './dao/permissions_dao';
import {PolicyDao} from './dao/policy_dao.js';
import {xrayProxiesDao} from './dao/proxies_dao';
import {ReportsDao} from './dao/reports_dao';
import {MaintenanceDao} from './dao/retry_messages_dao';
import {SaasDao} from './dao/saas_status_dao';
import {ScanDao} from './dao/scan_dao';
import {SecurityReportsDao} from './dao/security_reports_dao';
import {SessionsDao} from './dao/sessions_dao';
import {StatsDao} from './dao/stats_dao';
import {SupportDao} from './dao/support_dao';
import {UsersDao} from './dao/users_dao';
import {WatchersDao} from './dao/watchers_dao';
import {WebhooksDao} from './dao/webhooks_dao';
import {XRayUIDao, XRayUIDaoFactory} from './xray-ui_dao';
import {xrayUINotificationsInterceptor} from './xray-ui_notifications_interceptor.js';

angular.module('xray-ui.dao', ['ngResource', 'xray-ui.services'])
    .factory('xrayUINotificationsInterceptor', xrayUINotificationsInterceptor)
    .service('XRayUIDao', XRayUIDao)
    .factory('XRayUIDaoFactory', XRayUIDaoFactory)
    .service('UsersDao', UsersDao)
    .service('WebhooksDao', WebhooksDao)
    .service('SessionsDao', SessionsDao)
    .service('WatchersDao', WatchersDao)
    .service('AlertsDao', AlertsDao)
    .service('EventXDao', EventXDao)
    .service('ImpactDao', ImpactDao)
    .service('BinMgrDao', BinMgrDao)
    .service('XrayMailDao', XrayMailDao)
    .service('xrayProxiesDao', xrayProxiesDao)
    .service('LicenseDao', LicenseDao)
    .service('StatsDao', StatsDao)
    .service('ComponentsDao', ComponentsDao)
    .service('ScanDao', ScanDao)
    .service('XrayFooterDao', XrayFooterDao)
    .service('GeneralDao', GeneralDao)
    .service('HomepageDao', HomepageDao)
    .service('IntegrationDao', IntegrationDao)
    .service('GeneralSettingsDao', GeneralSettingsDao)
    .service('IgnoreDao', IgnoreDao)
    .service('DatabaseSyncDao', DatabaseSyncDao)
    .service('xrayLicensesDao', xrayLicensesDao)
    .service('MonitorDao', MonitorDao)
    .service('ReportsDao', ReportsDao)
    .service('SecurityReportsDao', SecurityReportsDao)
    .service('XrayOnboardingDao', XrayOnboardingDao)
    .service('BruteForceDao', BruteForceDao)
    .service('LogsDao', LogsDao)
    .service('XrayPermissionsDao', XrayPermissionsDao)
    .factory('xrayUINotificationsInterceptor', xrayUINotificationsInterceptor)
    .service('XRayUIDao', XRayUIDao)
    .factory('XRayUIDaoFactory', XRayUIDaoFactory)
    .service('UsersDao', UsersDao)
    .service('WebhooksDao', WebhooksDao)
    .service('SessionsDao', SessionsDao)
    .service('WatchersDao', WatchersDao)
    .service('AlertsDao', AlertsDao)
    .service('EventXDao', EventXDao)
    .service('ImpactDao', ImpactDao)
    .service('BinMgrDao', BinMgrDao)
    .service('XrayMailDao', XrayMailDao)
    .service('xrayProxiesDao', xrayProxiesDao)
    .service('LicenseDao', LicenseDao)
    .service('StatsDao', StatsDao)
    .service('ComponentsDao', ComponentsDao)
    .service('ScanDao', ScanDao)
    .service('XrayFooterDao', XrayFooterDao)
    .service('GeneralDao', GeneralDao)
    .service('HomepageDao', HomepageDao)
    .service('IntegrationDao', IntegrationDao)
    .service('GeneralSettingsDao', GeneralSettingsDao)
    .service('IgnoreDao', IgnoreDao)
    .service('DatabaseSyncDao', DatabaseSyncDao)
    .service('xrayLicensesDao', xrayLicensesDao)
    .service('MonitorDao', MonitorDao)
    .service('ReportsDao', ReportsDao)
    .service('SecurityReportsDao', SecurityReportsDao)
    .service('XrayOnboardingDao', XrayOnboardingDao)
    .service('BruteForceDao', BruteForceDao)
    .service('LogsDao', LogsDao)
    .service('AuthDao', AuthDao)
    .service('XrayNameValidatorDao', XrayNameValidatorDao)
    .service('CompLicensesDao', CompLicensesDao)
    .service('HADao', HADao)
    .service('PolicyDao', PolicyDao)
    .service('FailedMessagesDao', FailedMessagesDao)
    .service('XrayMaintenanceDao', MaintenanceDao)
    .service('SupportDao', SupportDao)
    .service('SaasDao', SaasDao)
    .service('XrayEffectivePermissionsDao', XrayEffectivePermissionsDao)



// WEBPACK FOOTER //
// ./modules/xray/data/xray-ui_dao_module.js